import React, { useEffect, useState, forwardRef, useMemo, useCallback } from 'react';
import { find } from 'lodash';
import { AppSecToolsIntegrationAPI } from 'restAPI/ToolsIntegrationAPI';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { FieldTypes } from 'utils/formUtils';

const NowSecureMappingForm = forwardRef((props, ref) => {
  const [applications, setApplications] = useState(() => {
    if (props.record) {
      const { applicationName, package:pack_age, platform, group } = props.record;
    
      return [{title: applicationName, pack_age , platform, group }]
    }
    return [];
  });
  useEffect(() => {
    const { promise, cancel } = AppSecToolsIntegrationAPI.getNowSecureReleases({ login_id: props.loginConfigId });
    promise.then((response) => {
      const { applications } = response;
      setApplications(applications);
    }).catch(() => {
      message.error('Problem fetching projects');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = useCallback((config) => {
    const { projectKey } = config;
    let applicationName = projectKey.split(' ');
    const application = find(applications, (obj) => (obj.pack_age) === applicationName[0] && (obj.platform) === applicationName[1] && obj.group === applicationName[2])
    const { pack_age, platform, title, group, groupName } = application;

    return ({
      package: pack_age,
      platform,
      applicationName: title,
      application: application.id,
      ...(group && {groupId: group, groupName: groupName})
    });
  },[applications]);

  const extraFields = useMemo(() => ([
    {
      name: 'projectKey',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'NowSecure Project',
      options: modifyOption(applications),
      rules: [{ required: true, message: `NowSecure Project is required` }],
      props: {
        autoFocus: true
      }
    }
  ]), [applications]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return ({
      projectKey: config.package + " " + config.platform + (config.group ? " " + config.group : ""),
      
    });
  }, []);

  return (
    <GenericMappingForm
      ref={ref}
      projects={applications}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      title='Map NowSecure Projects'
      {...props}
    />
  )
})

export default NowSecureMappingForm;


const modifyOption = (options) => {
  const optionObj = {};
  options.forEach(opt=> {
    if(!optionObj[opt?.groupName]){
      optionObj[opt.groupName] = [];
    }
    optionObj[opt.groupName].push({label: opt.title + "(" + opt.platform + ")", value: opt.pack_age + " " + opt.platform + (opt.group ? " " + opt.group : "") })
  })
  return Object.keys(optionObj).map(key=> {
    return {
      name: key,
      options: optionObj[key]
    }
  })
}